/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../axios-client";
import type { RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetUsersProfileCorpTransactionsQueryResponse, GetUsersProfileCorpTransactionsQueryParams, GetUsersProfileCorpTransactions400 } from "../entities/GetUsersProfileCorpTransactions";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getUsersProfileCorpTransactions } from "../api/getUsersProfileCorpTransactions";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getUsersProfileCorpTransactionsQueryKey = (params?: GetUsersProfileCorpTransactionsQueryParams) => [{ url: '/users/profile/corp-transactions' }, ...(params ? [params] : [])] as const

export type GetUsersProfileCorpTransactionsQueryKey = ReturnType<typeof getUsersProfileCorpTransactionsQueryKey>

export function getUsersProfileCorpTransactionsQueryOptions(params?: GetUsersProfileCorpTransactionsQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = getUsersProfileCorpTransactionsQueryKey(params)
  return queryOptions<GetUsersProfileCorpTransactionsQueryResponse, ResponseErrorConfig<GetUsersProfileCorpTransactions400>, GetUsersProfileCorpTransactionsQueryResponse, typeof queryKey>({
 
   queryKey,
   queryFn: async ({ signal }) => {
      config.signal = signal
      return getUsersProfileCorpTransactions(params, config)
   },
  })
}

/**
 * @description Получение истории транзакций corp
 * @summary Получение истории транзакций corp
 * {@link /users/profile/corp-transactions}
 */
export function useGetUsersProfileCorpTransactions<TData = GetUsersProfileCorpTransactionsQueryResponse, TQueryData = GetUsersProfileCorpTransactionsQueryResponse, TQueryKey extends QueryKey = GetUsersProfileCorpTransactionsQueryKey>(params?: GetUsersProfileCorpTransactionsQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<GetUsersProfileCorpTransactionsQueryResponse, ResponseErrorConfig<GetUsersProfileCorpTransactions400>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: typeof fetch }
}
 = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...queryOptions } = queryConfig
  const queryKey = queryOptions?.queryKey ?? getUsersProfileCorpTransactionsQueryKey(params)

  const query = useQuery({
   ...getUsersProfileCorpTransactionsQueryOptions(params, config),
   queryKey,
   ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetUsersProfileCorpTransactions400>> & { queryKey: TQueryKey }

  query.queryKey = queryKey as TQueryKey

  return query
}